export const reIndexComponents = (
  obj: Record<string, any>,
  removeIndexes: number[]
): Record<string, any> => {
  let updatedObj = {...obj};
  const regex = /(.*-tab-)(\d+)/;

  // Procesar cada índice a eliminar de manera secuencial
  for (const removeIndex of removeIndexes.sort((a, b) => a - b)) {
    const tempObj: Record<string, any> = {};
    let maxIndex = 0;

    // Obtener todas las claves ordenadas por índice
    const keysGroupedByIndex: Record<number, string[]> = {};
    for (const key of Object.keys(updatedObj)) {
      const match = key.match(regex);
      if (match) {
        const index = parseInt(match[2], 10);
        maxIndex = Math.max(maxIndex, index);
        if (!keysGroupedByIndex[index]) {
          keysGroupedByIndex[index] = [];
        }
        keysGroupedByIndex[index].push(key);
      } else {
        // Mantener claves que no coincidan con el patrón sin cambios
        tempObj[key] = updatedObj[key];
      }
    }

    // Si se está eliminando el último índice, solo pisar con undefined
    if (removeIndex === maxIndex) {
      for (const key of keysGroupedByIndex[maxIndex] || []) {
        tempObj[key] = undefined;
      }
    } else {
      // Reorganizar los índices después de la eliminación
      let newIndex = 1;
      const indices = Object.keys(keysGroupedByIndex)
        .map(Number)
        .sort((a, b) => a - b);

      for (let i = 0; i < indices.length; i++) {
        const oldIndex = indices[i];
        if (oldIndex === removeIndex) continue; // Saltar el índice eliminado

        for (const key of keysGroupedByIndex[oldIndex]) {
          const newKey = key.replace(regex, `$1${newIndex}`);
          tempObj[newKey] = updatedObj[key];
        }
        newIndex++;
      }

      // Agregar el último índice con valores undefined
      if (newIndex <= maxIndex) {
        for (const key of keysGroupedByIndex[maxIndex] || []) {
          const newKey = key.replace(regex, `$1${newIndex}`);
          tempObj[newKey] = undefined;
        }
      }
    }

    // Actualizar el objeto para la próxima iteración
    updatedObj = {...tempObj};
  }

  return updatedObj;
};
